// extracted by mini-css-extract-plugin
export default {"pillsContainer":"PillsToolbar_pillsContainer__u0SXc","pill":"PillsToolbar_pill__eZbs+","pillBorder":"PillsToolbar_pillBorder__3cHWB"};